import { createFileRoute } from '@tanstack/react-router';
import PrivacyPolicy from '../../components/privacy-policy/privacy-policy';
import { seo } from '../../utils/seo';

export const Route = createFileRoute('/_layout/legal/privacy-policy')({
  head: () => ({ meta: seo({ title: 'Adatkezelési tájékoztató' }) }),
  component: PrivacyPolicyRoute
});

function PrivacyPolicyRoute() {
  return (
    <div className="container-fluid">
      <div className="page-content centered">
        <h1 className="page-title">Adatkezelési tájékoztató</h1>
        <PrivacyPolicy />
      </div>
    </div>
  );
}
